/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Optimistic_Lock_ErrorInputs */

const cs_workflow_optimistic_lock_error = /** @type {(inputs: Workflow_Optimistic_Lock_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow byl mezitím změněn — obnovte stránku pro nejnovější verzi`)
};

const en_workflow_optimistic_lock_error = /** @type {(inputs: Workflow_Optimistic_Lock_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workflow was changed by someone else — reload to get the latest version`)
};

/**
* | output |
* | --- |
* | "The workflow was changed by someone else — reload to get the latest version" |
*
* @param {Workflow_Optimistic_Lock_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_optimistic_lock_error = /** @type {((inputs?: Workflow_Optimistic_Lock_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Optimistic_Lock_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_optimistic_lock_error(inputs)
	return cs_workflow_optimistic_lock_error(inputs)
});